import { endOfDay, format, isAfter, isValid, parse, setYear, startOfDay, } from "date-fns";
import { isNumber } from "lodash";
export const primaryDateFormat = "dd/MM/yyyy";
// Recommended date format for pg
export const pgDateFormat = "yyyy-MM-dd";
// Required date format for zoho
export const zohoDateFormat = "yyyy-MM-dd";
export const primaryTimeFormat = "hh:mm aa";
export const primaryDateTimeFormat = `${primaryDateFormat} ${primaryTimeFormat}`;
export const htmlFormDateTimeFormat = "yyyy-MM-dd'T'HH:mm";
export const readableDateTimeFormat = "d MMMM yyyy, h.mm a";
export const logDateTimeFormat = "yyyy-MM-dd-HH-mm";
// Should only be used for data being imported
//
// Attempts to parse a few common formats which are not mutually ambiguous
export function gracefullyParseDate(dInput, defaults, formats = ["dd/MM/yyyy", "dd/MM", "dd-MM", "dd-MMM", "dd/MMM"]) {
    const d = dInput?.trim();
    if (!d)
        return null;
    let fallback = startOfDay(new Date());
    if (defaults?.year) {
        fallback = setYear(fallback, defaults.year);
    }
    let parsed;
    for (const format of formats) {
        parsed = parse(d, format, fallback);
        if (isValid(parsed))
            return parsed;
    }
    throw new TypeError(`Invalid date: ${d}`);
}
export function parseDate(d) {
    if (!d)
        return null;
    const parsed = parse(d, primaryDateFormat, new Date());
    if (!isValid(parsed))
        throw new TypeError(`Invalid date: ${d}`);
    return parsed;
}
export function parseDateFromHTMLInput(d) {
    if (!d)
        return null;
    const parsed = parse(d, htmlFormDateTimeFormat, new Date());
    if (!isValid(parsed))
        throw new TypeError(`Invalid date: ${d}`);
    return parsed;
}
export function formatDate(d, formatStr = primaryDateFormat) {
    if (!d)
        return null;
    if (d instanceof Date || isNumber(d))
        return format(d, formatStr);
    return `${d}`;
}
export function parseDateTime(d) {
    if (!d)
        return null;
    const parsed = parse(d, primaryDateTimeFormat, new Date());
    if (!isValid(parsed))
        throw new TypeError(`Invalid date: ${d}`);
    return parsed;
}
export const formatDateAsReadable = (d) => {
    if (!d)
        return "";
    return format(d, "d MMMM, yyyy");
};
export const formatDateTime = (d, formatStr = primaryDateTimeFormat) => {
    if (!d)
        return null;
    if (d instanceof Date || isNumber(d))
        return format(d, formatStr);
    return `${d}`;
};
export const formatTime = (d, formatStr = primaryTimeFormat) => {
    if (!d)
        return null;
    if (d instanceof Date || isNumber(d))
        return format(d, formatStr);
    return `${d}`;
};
export const formatDateTimeForHTMLInput = (d) => {
    if (!d)
        return "";
    return format(d, htmlFormDateTimeFormat);
};
export const formatDateTimeAsReadable = (d) => {
    if (!d)
        return "";
    return format(d, readableDateTimeFormat);
};
export function dayStart(d) {
    const parsed = parseDate(d);
    if (!parsed)
        return null;
    return startOfDay(parsed);
}
export function dayEnd(d) {
    const parsed = parseDate(d);
    if (!parsed)
        return null;
    return endOfDay(parsed);
}
export function now() {
    return Date.now();
}
export function formatDateInputAsReadable(value) {
    if (!value)
        return "-";
    const date = value instanceof Date
        ? value
        : new Date(typeof value === "number" ? value : Date.parse(value));
    if (Number.isNaN(date.getTime()))
        return "-";
    return formatDateAsReadable(date);
}
export function formatDateTimeRangeFromSlot(start, durationMins) {
    if (!start)
        return "";
    const startDate = start instanceof Date
        ? start
        : new Date(typeof start === "number" ? start : Date.parse(start));
    if (Number.isNaN(startDate.getTime()))
        return "";
    const endDate = durationMins && durationMins > 0
        ? new Date(startDate.getTime() + durationMins * 60 * 1000)
        : null;
    const dateLabel = formatDateAsReadable(startDate);
    const startTime = startDate.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
    });
    const endTime = endDate
        ? endDate.toLocaleTimeString(undefined, {
            hour: "numeric",
            minute: "2-digit",
        })
        : null;
    const timeRange = endTime ? `${startTime} - ${endTime}` : startTime;
    return `${dateLabel}, ${timeRange}`;
}
export function formatDurationShort(secs) {
    if (secs == null || !Number.isFinite(secs) || secs < 0)
        return null;
    const total = Math.round(secs);
    const hours = Math.floor(total / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const rem = total % 60;
    if (hours)
        return `${hours}h ${mins}m`;
    if (mins)
        return `${mins}m ${rem}s`;
    return `${rem}s`;
}
export function isDateAfter(laterDate, earlierDate) {
    if (!laterDate || !earlierDate)
        return false;
    return isAfter(laterDate, earlierDate);
}
// export const addDuration = (start: DateInput, duration: IDurationInput) => {
//     const input = toNum(duration.input);
//     switch (duration.unit) {
//         case "DAYS": return addDays(start, input);
//         case "WEEKS": return addWeeks(start, input);
//         case "MONTHS": return addMonths(start, input);
//     }
// };
//# sourceMappingURL=datetime.js.map